
export default function CursosSection() {
  return (
    <section className="flex-container">

    </section>
  );
};